import { apolloClient } from "@td/ui";
import PANEL_VIEW_PREFERENCES_QUERY from "../queries/panel-view-preferences.graphql";

const fetchPreferredSpecialty = async () => {
  const { data: { userViewPreferences: { specialty } } } = await apolloClient.query({
    fetchPolicy: "network-only",
    query:  PANEL_VIEW_PREFERENCES_QUERY,
  });

  return specialty;
};

export default fetchPreferredSpecialty;
